import { appendPath, getValue } from '@truqc/content-path';
import { createSelector } from 'reselect';
import newPathSelector from './newPathSelector';
import { getContent, getStaticContent } from './simpleSelectors';
const getEmptyLabel = (state, props) => props.emptyLabel;
const getLabel = (state, props) => {
  let {
    label
  } = props;
  if (label === undefined && props.format !== undefined) {
    ({
      label
    } = props.format);
  }
  return label;
};
const getLabelContentPath = (s, props) => {
  let {
    labelContentPath
  } = props;
  if (labelContentPath === undefined && props.format !== undefined) {
    ({
      labelContentPath
    } = props.format);
  }
  return labelContentPath;
};
export default createSelector([getContent, getStaticContent, getLabel, getLabelContentPath, newPathSelector, getEmptyLabel], (content, staticContent, label, labelContentPath, path, emptyLabel) => {
  if (emptyLabel) return '';
  let result = null;
  if (label !== undefined) {
    result = label;
  } else if (labelContentPath !== undefined) {
    const labelPath = appendPath(path, labelContentPath);
    result = getValue(labelPath, content);
    if (result === undefined) {
      result = getValue(labelPath, staticContent);
    }
  }
  return result;
});